"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useInterval_1 = __importDefault(require("./useInterval"));
/**
 * Detects when a user becomes idle (does
 * not interact with the page for some time).
 *
 * Returns true if user is idle.
 *
 * @param userConfig Configuration.
 */
function useIdle(timeToIdle) {
    if (timeToIdle === void 0) { timeToIdle = 20; }
    var _a = __read(react_1.useState(false), 2), isIdle = _a[0], setIsIdle = _a[1];
    // const configuration = { timeToIdle: 20, ...config };
    useInterval_1.default(function () {
        // foo
    }, timeToIdle * 1000);
    var makeActive = react_1.useCallback(function () {
        setIsIdle(false);
    }, []);
    react_1.useEffect(function () {
        // const activityDetector = createActivityDetector({
        //   ...configuration,
        //   timeToIdle: configuration.timeToIdle * 1000,
        // });
        // activityDetector.on('idle', () => setIsIdle(true));
        // activityDetector.on('active', () => setIsIdle(false));
        document.addEventListener('mousemove', makeActive, false);
        document.addEventListener('mousedown', makeActive, false);
        document.addEventListener('keypress', makeActive, false);
        document.addEventListener('touchmove', makeActive, false);
        return function () {
            document.removeEventListener('mousemove', makeActive, false);
            document.removeEventListener('mousedown', makeActive, false);
            document.removeEventListener('keypress', makeActive, false);
            document.removeEventListener('touchmove', makeActive, false);
        };
        // return (): void => activityDetector.stop();
    }, [makeActive]);
    return isIdle;
}
exports.default = useIdle;
//# sourceMappingURL=useIdle.js.map